import React from 'react'
import { Avatar, makeStyles, tokens } from '@fluentui/react-components'
import { Text } from '../text/Text'
import { getFullName } from '../../../helpers/accountHelper'
import { ProcessOwner } from '../../../api/schemas/schema'
const useStyles = makeStyles({
   marginTopXS: {
      marginTop: tokens.spacingVerticalXS,
   },
   avatarSpacer: {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacingHorizontalS,
   },
})

type ProcessOwnerAvatarOutputProps = {
   processOwner: ProcessOwner
   label?: string
   bold?: boolean
}
export const ProcessOwnerAvatarOutput = ({ processOwner, label, bold}: ProcessOwnerAvatarOutputProps) => {
   const classes = useStyles()
   const name = processOwner.userAccount ? getFullName(processOwner.userAccount) : processOwner.ownerFreeText

   return (
      <div>
         <Text style={{ margin: 0 }} weight="semibold">
            {label}
         </Text>
         <div className={classes.avatarSpacer}>
            <Avatar name={name} className={classes.marginTopXS} />
            <Text size={400} weight={bold ?'semibold' : 'regular'}>{name}</Text>
         </div>
      </div>
   )
}
